import * as Task01 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaSqrtDifferenceSquareClosedTask";
import { getMaturaTaskTypeCode3 } from "../maturaTaskClassification";
import * as Task02 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaPowerFactorOutClosedTask";
import * as Task03 from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLogSingleCoefClosedTask";
import * as Task04 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaBinomialDifferencePolynomialClosedTask";
import * as Task05 from "../../generators/dzial10_dowody/temat3_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaRemainderDivisibilityOpenTask";
import * as Task06 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaLinearInequalityGraphClosedTask";
import * as Task07 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaFactoredRealRootsClosedTask";
import * as Task08 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat2_maturalne_zamkniete_types/MaturaRationalExpressionClosedTask";
import * as Task09 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaPercentLinearSystemBusinessOpenTask";
import * as Task10 from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat3_maturalne_otwarte_types/MaturaScaledQuadraticInequalityOpenTask";
import * as Task11 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaPiecewiseFunctionContinuousOpenTask";
import * as Task121 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaQuadraticCanonicalFromGraphOpenTask";
import * as Task122 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaQuadraticAxisFromGraphClosedTask";
import * as Task123 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaQuadraticShiftBy3ZerosSumOpenTask";
import * as Task13 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaLinearNoZeroClosedTask";
import * as Task141 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaRecursiveSequenceTermClosedTask";
import * as Task142 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaRecursiveSequencePFClosedTask";
import * as Task15 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaArithmeticTripletParamOpenTask";
import * as Task16 from "../../generators/dzial4_ciagi/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaGeometricTermClosedTask";
import * as Task17 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaTrigTanRelationClosedTask";
import * as Task18 from "../../generators/dzial5_trygonometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_zamkniete_types/MaturaRightTriangleTwoTrigClosedTask";
import * as Task19 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaInscribedCentralBaseAngleClosedTask";
import * as Task20 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaSimilarIsoscelesTriangleClosedTask";
import * as Task21 from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaTriangleSineCosinePFClosedTask";
import * as Task22 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaSquareDiagonalCenterClosedTask";
import * as Task23 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaParallelLinesParameterClosedTask";
import * as Task24 from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCircleCenterPointEquationClosedTask";
import * as Task25 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaConeVolumeOpeningOpenTask";
import * as Task26 from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaCubeVolumeDiagonalClosedTask";
import * as Task27 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaDigitOnceClosedTask";
import * as Task28 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaTwoDiceSumEqualsClosedTask";
import * as Task29 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat2_zamkniete_types/MaturaMeanSevenXYSumClosedTask";
import * as Task30 from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaGradesMedianModeOpenTask";
import * as Task31 from "../../generators/dzial3_funkcje/temat6_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaCuboidSurfaceOptimizationOpenTask";

export const sheet = {
  id: "cke-p-2025-maj",
  title: "Matura z matematyki 2025 – termin główny",
  subtitle: "Poziom podstawowy, 7 maja 2025",
  sourceLabel: "CKE • Formuła 2023",
  sessionType: "main",
  taskCount: 31,
  maxPoints: 50,
};

const taskModules = [
  Task01, Task02, Task03, Task04, Task05, Task06, Task07, Task08, Task09,
  Task10, Task11, Task121, Task122, Task123, Task13, Task141, Task142,
  Task15, Task16, Task17, Task18, Task19, Task20, Task21, Task22,
  Task23, Task24, Task25, Task26, Task27, Task28, Task29, Task30, Task31,
];

const pointsByTaskNumber = {
  "1": 1, "2": 1, "3": 1, "4": 1, "5": 2, "6": 1, "7": 1,
  "8": 1, "9": 2, "10": 2, "11": 4,
  "12.1": 2, "12.2": 1, "12.3": 1, "13": 1,
  "14.1": 1, "14.2": 1, "15": 3, "16": 1,
  "17": 1, "18": 2, "19": 1, "20": 1, "21": 1,
  "22": 1, "23": 1, "24": 1, "25": 3, "26": 1, "27": 1,
  "28": 1, "29": 1, "30": 2, "31": 4,
};

const moduleByType = Object.create(null);

function decorateTask(task) {
  const taskNumber = String(task?.source?.taskNumber ?? "");
  const match = /^(\d+)(?:\.(\d+))?$/.exec(taskNumber);
  if (!match) return task;

  const baseNumber = Number(match[1]);
  if (!match[2]) return { ...task, displayBaseNumber: baseNumber };

  return {
    ...task,
    displayBaseNumber: baseNumber,
    maturaGroupId: match[1],
    maturaGroupPart: Number(match[2]),
  };
}

export function generateTasks(variant = "original") {
  return taskModules.map((taskModule) => {
    const original = taskModule.generateTask({ variant: "original", session: "2025_MAJ" });
    moduleByType[original.type] = taskModule;
    if (variant !== "random") return decorateTask(original);
    // Wariant losowy: generujemy losowa wersje, ale zachowujemy numer zadania
    // z oryginalu, aby uklad i numeracja arkusza pozostaly spojne.
    const randomTask = taskModule.generateTask({ variant: "random", session: "2025_MAJ" });
    randomTask.source = { ...(randomTask.source || {}), taskNumber: original.source?.taskNumber };
    moduleByType[randomTask.type] = taskModule;
    return decorateTask(randomTask);
  });
}

export function generatePagedTasks(variant = "original") {
  return generateTasks(variant).map((task, index) => {
    const taskNumber = String(task.source.taskNumber);
    return {
      index,
      task,
      meta: {
        taskNo: taskNumber,
        code3: getMaturaTaskTypeCode3(task),
        maxPoints: pointsByTaskNumber[taskNumber] || 1,
      },
    };
  });
}

function getModule(task) {
  // Restored exercises may render before this sheet has generated any tasks.
  if (!moduleByType[task?.type]) generateTasks("original");
  const taskModule = moduleByType[task?.type];
  if (!taskModule) {
    throw new Error(`Brak modułu oficjalnego zadania: ${task?.type || "unknown"}`);
  }
  return taskModule;
}

export function renderTask(task) {
  return getModule(task).renderTask(task);
}

export function getInteractionSupport(task) {
  const taskModule = getModule(task);
  return {
    renderInput: typeof taskModule.renderInput === "function",
    checkAnswer: typeof taskModule.checkAnswer === "function",
    renderUserAnswer: typeof taskModule.renderUserAnswer === "function",
  };
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return getModule(task).renderInput?.(task, userAnswer, onChange, disabled) ?? null;
}

export function checkAnswer(task, userAnswer) {
  return getModule(task).checkAnswer?.(task, userAnswer) ?? false;
}

export function renderUserAnswer(userAnswer, task) {
  return getModule(task).renderUserAnswer?.(userAnswer, task) ?? null;
}

export function renderAnswer(task) {
  return getModule(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return getModule(task).renderExplanation(task);
}
